import { AppConfig } from '../services/appConfig'
import { genericError, networkError } from '../widgets/modal'
import GridHandler from './handlers/gridHandler'

export default class Sports extends GridHandler {
  get pageText() {
    return 'Pick your sport'
  }

  async _init() {
    this._isRoot = true
    this._isSportPicker = true

    this._setState('NotReady')

    await this.getSportsCategoriesData()
  }

  async getSportsCategoriesData() {
    const data = await AppConfig.shared.experienceApi.getSports()

    if (data?.error) {
      const error = data.isNetworkError ? networkError : genericError
      this.setModal(true, error)
      return
    }

    this.tvGridLayout.data = data
    this.currentRow = this._lastFocusedRow ?? 0
    this.currentTile = this._lastFocusedTile ?? 0
    const originalyCoordinate = this.tvGridLayout.tvGridContainer.y
    this.tvGridLayout.tvGridContainer.y = this._lastYOffset ?? originalyCoordinate
    this._refocus()

    this._setState('Ready')
  }
}
